var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-advanced-chat",
    {
      ref: "vacRef",
      attrs: {
        height: _vm.chatWindowHeight,
        "username-options": JSON.stringify(_vm.usernameOptions),
        "scroll-distance": 60,
        "auto-scroll": JSON.stringify(_vm.autoScrollOptions),
        "single-room": "true",
        "current-user-id": _vm.currentUserId,
        "show-audio": "false",
        "show-files": "false",
        "accepted-files": ".jpeg,.jpg,.gif,.png,.svg,.docx,.ppt,.xls",
        rooms: JSON.stringify(_vm.rooms),
        messages: JSON.stringify(_vm.messages),
        "message-selection-actions": JSON.stringify(
          _vm.messageSelectionActions
        ),
        "message-actions": JSON.stringify(_vm.messageActions),
        "messages-loaded": _vm.allMessagesLoaded,
        "rooms-loaded": _vm.roomsLoaded,
        "load-first-room": false,
        "room-info-enabled": "false",
        "text-formatting": JSON.stringify(_vm.textFormatting),
        "textarea-auto-focus": "false",
        "link-options": JSON.stringify(_vm.linkOptions),
        styles: JSON.stringify(_vm.styleOverrides),
        "show-reaction-emojis": "false"
      },
      on: {
        "send-message-reaction": _vm.sendMessageReaction,
        "message-selection-action-handler": _vm.messageSelectionActionHandler,
        "fetch-messages": _vm.fetchMessages,
        "send-message": _vm.sendMessage,
        "edit-message": _vm.editMessage,
        "delete-message": _vm.deleteMessage,
        "read-new-message": _vm.markNewMessageAsRead
      }
    },
    _vm._l(_vm.messages, function(message) {
      return _c(
        "div",
        {
          attrs: { slot: "pencil-icon_" + message._id },
          slot: "pencil-icon_" + message._id
        },
        [_c("span", [_vm._v("Edited")])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }